import React from 'react';
import PropTypes from 'prop-types';

class Invoice extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Invoice';
    }
    render() {
        return <div>Invoice</div>;
    }
}

export default Invoice;



// WEBPACK FOOTER //
// ./src/browser/components/account/invoice.js